import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { ORGANIZED_TOUR_CURATED_GENERIC_TRAVEL_URL } from "../../../../utils/organizedTourHeroImageSsot";
import { useOrgTourHeroImageLayoutTrace } from "../../../../modules/organizedTours/hooks/useOrgTourHeroImageLayoutTrace";

function formatPriceIls(value) {
  if (value == null || !Number.isFinite(Number(value))) return "—";
  return `${Math.round(Number(value)).toLocaleString("he-IL")} ₪`;
}

export default function OrganizedTourProfileHero({
  viewModel,
  onPrimaryCta,
  primaryCtaLabel = "המשך להזמנה",
}) {
  const vm = viewModel || {};
  const imgSrc = vm.heroImage || ORGANIZED_TOUR_CURATED_GENERIC_TRAVEL_URL;
  const mediaRef = useRef(null);
  const imgRef = useRef(null);
  const { onHeroImageLoad } = useOrgTourHeroImageLayoutTrace({
    imageUrl: imgSrc,
    mediaRef,
    imgRef,
  });

  useEffect(() => {
    if (!import.meta.env?.DEV) return;
    console.log("[ORG_TOUR_PROFILE_HERO_RESOLVE]", {
      tourName: vm.tourName,
      resolvedImage: vm.heroImage || null,
      imageSource: vm.imageSource,
      fallbackUsed: vm.heroImageFallbackUsed,
    });
  }, [vm.tourName, vm.heroImage, vm.imageSource, vm.heroImageFallbackUsed]);

  return (
    <motion.header
      className="otp-hero"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      <div ref={mediaRef} className="otp-hero__media">
        <img
          ref={imgRef}
          src={imgSrc}
          alt={vm.tourName || "טיול מאורגן"}
          loading="eager"
          decoding="async"
          data-image-source={vm.imageSource || "none"}
          onLoad={onHeroImageLoad}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = ORGANIZED_TOUR_CURATED_GENERIC_TRAVEL_URL;
          }}
        />
        <div className="otp-hero__gradient" aria-hidden />
        <span className="otp-hero__badge">טיול מאורגן</span>
      </div>

      <div className="otp-hero__content">
        <div className="otp-hero__text">
          <h1 className="otp-hero__title">{vm.tourName || "טיול מאורגן"}</h1>
          {vm.routeLabel ? (
            <p className="otp-hero__route">{vm.routeLabel}</p>
          ) : null}
          <div className="otp-hero__dates">
            <span>יציאה: {vm.depDateLabel}</span>
            {vm.retDateLabel && vm.retDateLabel !== "—" ? (
              <span>חזרה: {vm.retDateLabel}</span>
            ) : null}
            {vm.nights != null && Number.isFinite(vm.nights) ? (
              <span>{vm.nights} לילות</span>
            ) : null}
          </div>
          {vm.supplierLabel ? (
            <p className="otp-hero__supplier">קוד ספק: {vm.supplierLabel}</p>
          ) : null}
          {vm.displayOfferNumber ? (
            <p className="otp-hero__hr">מספר הצעה: {vm.displayOfferNumber}</p>
          ) : null}
        </div>

        <div className="otp-hero__aside">
          <div className="otp-hero__price-block">
            <span className="otp-hero__price-label">סה״כ להזמנה</span>
            <span className="otp-hero__price">{formatPriceIls(vm.priceIls)}</span>
          </div>
          {typeof onPrimaryCta === "function" ? (
            <button type="button" className="otp-hero__cta" onClick={onPrimaryCta}>
              {primaryCtaLabel}
            </button>
          ) : null}
        </div>
      </div>
    </motion.header>
  );
}
